<template>
    <ul class="batch_operate_bar">
        <li v-for="item in operateBarList" @click="handleClickItem(item)" :class="{'active': operateBarType == item.type}">
            <div class="item_icon"><i :class="['iconfont', item.icon]"></i></div>
            <div class="item_text">{{ item.title }}</div>
        </li>
    </ul>
</template>
<script>
export default {
    name: "BatchOperateBar",
    props: {
        operateBarList: {
            type: Array,
            default: [],
        },
    },
    data() {
        return {
            operateBarType: ""
        };
    },
    methods: {
        handleClickItem(item) {
            this.operateBarType = item.type
            this.$emit("handleClickOperateType", item.type)
        } 
    }
};
</script>
<style lang="scss" scoped>
.batch_operate_bar {
    position: fixed;
    bottom: 0;
    z-index: 9999;
    display: flex;
    box-sizing: content-box;
    width: 100%;
    height: 50px;
    background-color: #fff;
    li {
        flex: 1;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        color: rgba(102, 102, 102, 1);
        font-size: 12px;
        line-height: 1;
        cursor: pointer;
        .item_icon {
            margin-bottom: 2px;
            .iconfont {
                font-size: 18px;
            }
        }
        &:active , &.active{
            color: rgba(153, 153, 153, 1);
        }
    }
}
</style>
